export const LTI_SESSION_COOKIE = 'lti_session';
export const LTI_CSRF_COOKIE = 'lti_csrf';
export const LTI_SESSION_MAX_AGE_SECONDS = 2 * 60 * 60;
